import { useCallback, useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { usePermission } from '../hooks/use-permission';
import { MOBILE_LANDSCAPE_QUERY } from '../theme';
import { Provider as ExperienceProvider } from './context';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';

function usePhoneToggle() {
  const [forcePhone, setForcePhone] = useState(
    () => sessionStorage.getItem('forcePhone') === 'true',
  );

  const handleKeyDown = useCallback((e) => {
    if (e.ctrlKey && e.shiftKey && e.key === 'M') {
      e.preventDefault();
      setForcePhone((prev) => {
        const next = !prev;
        sessionStorage.setItem('forcePhone', next);
        return next;
      });
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return forcePhone;
}

export function Experience() {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobileLandscape = useMediaQuery(MOBILE_LANDSCAPE_QUERY);
  const isAdmin = usePermission('ADMIN_LOOKUP');
  const isSignalViewer = usePermission('VIEW_SIGNAL');
  const forcePhone = usePhoneToggle();
  const isOnPhone = isSmall || isMobileLandscape;
  const shouldRouteToSignal = !isAdmin && isSignalViewer;
  const showPhoneExperience = isOnPhone && shouldRouteToSignal;

  return (
    <ExperienceProvider isPhone={showPhoneExperience}>
      {forcePhone || showPhoneExperience ? <Mobile /> : <Desktop />}
    </ExperienceProvider>
  );
}
